<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <div v-if="!loading && (video || slides.length)">
        <Video v-if="video" />

        <SlideShowSection v-else-if="slides.length" />
      </div>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../../widgets/LoadingWidget.vue";
import Video from "./Video.vue";
import SlideShowSection from "./SlideShowSection.vue";

export default {
  data: () => ({
    loading: true,
  }),
  created() {
    const video = this.$rest("video").get({
      save: (state, data) => (state.item = data),
    });

    const slides = this.$rest("slides").get();

    Promise.all([video, slides]).then(() => (this.loading = false));
  },
  computed: {
    video() {
      const video = this.$rest("video").item;
      if (!video.video_desktop) return "";

      return this.xsOnly && video.video_mobile
        ? video.video_mobile
        : video.video_desktop;
    },
    slides() {
      return this.$rest("slides").list;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  components: {
    LoadingWidget,
    Video,
    SlideShowSection,
  },
};
</script>
